import Error from "next/error";
import { useEffect } from "react";
import { useUser } from "../contexts/user";
import BugsnagClient from "../utils/bugsnag";

export const ErrorPage = ({ statusCode }) => {
  const { user } = useUser();

  useEffect(() => {
    if (user) {
      BugsnagClient.setUser(user.id, user.email);
    }
  }, [user]);

  return <Error statusCode={statusCode} title="Oops, something isn't right." />;
};

ErrorPage.getInitialProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode };
};

export default ErrorPage;
